export default __webpack_public_path__ + "static/media/MR.0a8c0e2b.svg";